import React from 'react'
import { withTranslation } from 'react-i18next'
import collapseTimer from '../../assets/img/developing/timer.svg'
import collapseArrow from '../../assets/img/developing/arrow.svg'
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class Program extends React.Component {
    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="collapse__wrapper">
                            <div className="collapse__visible d-flex align-items-center justify-content-between program__collapse collapsed">
                                <Skeleton className="collapse__title collapse__visible_left md-font-size" width={200} />
                                <div className="collapse__visible_right d-flex align-items-center justify-content-end">
                                    <Skeleton className="collapse__time d-flex align-items-end xs-font-size" width={90} />
                                    <Skeleton className="ml-3" width={15} height={15} circle={true} style={{ verticalAlign: 'text-top' }} />
                                </div>
                            </div>
                        </div>
                        :
                        <div className="collapse__wrapper">
                            <div className="collapse__visible d-flex align-items-center justify-content-between collapse__pointer program__collapse collapsed" data-toggle="collapse" href={`#program-collapse-${this.props.id}`} role="button" aria-expanded="false" aria-controls={`program-collapse-${this.props.id}`}>
                                <p className="collapse__title collapse__visible_left md-font-size">{this.props.title}</p>
                                <div className="collapse__visible_right d-flex align-items-center justify-content-end">
                                    <img src={collapseTimer} alt="timer" className="collapse__timer" />
                                    <p className="collapse__time d-flex align-items-end xs-font-size">{this.props.duration} {t('catalog-minutes')}</p>
                                    <img src={collapseArrow} alt="arrow" className="colapse__arrow" />
                                </div>
                            </div>
                            <div className="collapse__content collapse" id={`program-collapse-${this.props.id}`}>
                                {this.props.modules.map((mod) => (<div key={mod.id}><p className="md-font-size">{mod.title}</p></div>))}
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

Program.propTypes = {
    t: PropTypes.func,
    title: PropTypes.string,
    modules: PropTypes.array,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    duration: PropTypes.number,
    skeleton: PropTypes.bool,
}

export default withTranslation()(Program)



// WEBPACK FOOTER //
// ./src/components/Catalog/Program.jsx